import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import CustomLoader from '../common/CustomLoader';
import CustomSelect from '../home/collections/CustomSelect';
import ParentContentCard from '../common/ParentContentCard';
import { dropdownsForSource } from '../../common/utils/data_source-util';
import { getFieldDataTypeValue } from './common/common_utils';
import { convertAttributesToFieldData } from './common/common_utils';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import CustomRadio from '../../common/ui/CustomRadio';
import AlertMessageBox from '../../common/ui/AlertMessageBox';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class AppwriteCollectionUpdate extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    fieldDatatypes: [],
    collectionDetailsByAppwrite: '',
    externaldbAppwrite: '',
  };
  async componentDidMount() {
    const { match, actions, dataConnector } = this.props;
    const { dbUuid, projectId, collectionId, version } = match.params;
    await actions.loadAppwriteExternaldb({ projectId, dbUuid, version });
    this.setState({ externaldbAppwrite: this.props.dataConnector.externaldbAppwrite });
    const { setting, completeData } = this.state.externaldbAppwrite;
    this.setState({ completeEx: completeData });
    const { database } = completeData;
    await actions.loadAppwriteCollectionDetails({
      setting,
      databaseId: database.id,
      collectionId,
      projectId,
      version,
    });
    this.setState({
      collectionDetailsByAppwrite: this.props.dataConnector.collectionDetailsByAppwrite,
    });
  }

  handleFieldChange = (fieldName, selectedValue) => {
    const updatedResult = { ...this.state.fieldDatatypes };
    updatedResult[fieldName[0]] = selectedValue;
    this.setState({ fieldDatatypes: updatedResult });
  };
  handleSave = async (values, selectedPrimaryKey) => {
    const { match, actions, history } = this.props;
    const { dbUuid, projectId, collectionId, version } = match.params;
    const { collectionDetailsByAppwrite, fieldDatatypes, externaldbAppwrite } = this.state;
    const { completeData, name, setting } = externaldbAppwrite ? externaldbAppwrite : '';
    const { tables } = completeData ? completeData : '';
    const selectedColl = tables
      ? tables.find((el) => {
          return el.collectionId == collectionId;
        })
      : null;
    const fieldData = selectedColl ? selectedColl.fields : '';
    const result = {};
    Object.keys(fieldData).map((fieldName, index) => {
      result[fieldName] = fieldDatatypes[fieldName]
        ? fieldDatatypes[fieldName].value
        : fieldData[fieldName];
    });

    const { database } = completeData;
    const dataforUpdate = {
      collectionTitle: values.collectionTitle,
      orgCollectionName: collectionDetailsByAppwrite.name,
      collectionNames: collectionDetailsByAppwrite.name,
      fields: result,
      projectId,
      externalDatabaseId: dbUuid,
      setting,
      databaseId: database.id,
      collectionId,
      version,
      name,
      selectedPrimaryKey,
    };
    await actions.appwriteCollectionUpdate(dataforUpdate);
    await actions.appwriteUpdateExternalDatabase({
      collectionTitle: values.collectionTitle,
      projectId,
      externalDbUuid: dbUuid,
      result,
      version,
      collectionId,
      selectedPrimaryKey,
    });
    history.push(`/2.0/data-connector/${version}/v/${projectId}/appwrite-edit/${dbUuid}`);
  };
  handleCancel = () => {
    const { match, history } = this.props;
    const { dbUuid, projectId, version } = match.params;
    history.push(`/2.0/data-connector/${version}/v/${projectId}/appwrite-edit/${dbUuid}`);
  };
  showAlertMessage = () => {
    return (
      <AlertMessageBox
        type="info"
        text={`Note: If no primary key is selected below, the system will default to using the 
<strong>'id'</strong> field as the primary key for External APIs.`}
      />
    );
  };

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />
        </CommonPageComponent>
      );
    }
    const { collectionDetailsByAppwrite, fieldDatatypes, externaldbAppwrite } = this.state;
    const { dataConnector, match } = this.props;
    const { collectionId } = match.params;
    const { completeData } = externaldbAppwrite ? externaldbAppwrite : '';
    const { tables } = completeData ? completeData : '';
    const {
      loadAppwriteExternaldbPending,
      loadAppwriteCollectionDetailsPending,
      appwriteCollectionUpdatePending,
    } = dataConnector;
    const selectedColl = tables
      ? tables.find((el) => {
          return el.collectionId == collectionId;
        })
      : null;
    const fieldData = selectedColl ? selectedColl.fields : '';

    if (!fieldData)
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader
              loading={loadAppwriteExternaldbPending || loadAppwriteCollectionDetailsPending}
              size="20px"
              color="#303453"
            />
          </div>
        </CommonPageComponent>
      );
    return fieldData ? (
      <CommonPageComponent>
        <ParentContentCard title={'Collection for Update via Appwrite'} icon={'collection'}>
          <Formik
            initialValues={{
              collectionTitle: selectedColl.collectionTitle || selectedColl.collectionName,
            }}
            enableReinitialize={true}
          >
            {({ values, handleChange, setFieldValue }) => (
              <Form className="ml-5">
                <div className="col-md-11 col-lg-11 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Name"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Appwrite collection name'}
                    >
                      <Field
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Collection Name"
                        readOnly
                        value={selectedColl.collectionName}
                      />
                    </FormFieldWithLabel>
                  </div>

                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection Title"
                      icon="text"
                      infoIcon={true}
                      infoDescription={'Enter name for the collection name if  you want to change'}
                    >
                      <Field
                        type="text"
                        name="collectionTitle"
                        className="form-control form-control-sm"
                        placeholder="Collection Title"
                        value={values.collectionTitle}
                        onChange={(e) => setFieldValue('collectionTitle', e.target.value)}
                      />
                      <ErrorMessage name="collectionTitle" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                  <hr style={{ marginBottom: '20px', visibility: 'hidden' }} />
                  {this.showAlertMessage()}
                  <div className="mt-2">
                    <h5>
                      <b>Field Type Mapping</b>
                    </h5>
                  </div>

                  <div
                    className="table-responsive"
                    style={{ overflow: 'visible', maxHeight: 'fit-content', marginBottom: '10px' }}
                  >
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Fields</th>
                          <th>Types</th>
                          {selectedColl.selectedPrimaryKey != 'id' && (
                            <th style={{ width: '12%' }}>Primary Key</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {Object.keys(fieldData).map((fieldName, index) => (
                          <tr key={index}>
                            <td>{fieldName}</td>
                            <td>
                              <CustomSelect
                                name={fieldName}
                                isMulti={false}
                                onChange={setFieldValue}
                                onChangeValue={this.handleFieldChange}
                                options={dropdownsForSource}
                                value={getFieldDataTypeValue(fieldName, fieldData, fieldDatatypes)}
                              />
                            </td>
                            {selectedColl.selectedPrimaryKey !== 'id' && (
                              <td style={{ width: '12%' }}>
                                {selectedColl.selectedPrimaryKey ? (
                                  <div className="form-check ml-4 pl-3">
                                    <CustomRadio label="" isRadio={false}>
                                      <Field
                                        type="checkbox"
                                        name={fieldName}
                                        className="form-check-input"
                                        checked={
                                          selectedColl.selectedPrimaryKey === fieldName
                                            ? true
                                            : false
                                        }
                                        disabled={
                                          selectedColl.selectedPrimaryKey === fieldName
                                            ? false
                                            : true
                                        }
                                      />
                                    </CustomRadio>
                                  </div>
                                ) : (
                                  <div className="form-check ml-4 pl-3">
                                    <CustomRadio label="" isRadio={false}>
                                      <Field
                                        type="checkbox"
                                        name={fieldName}
                                        className="form-check-input"
                                        checked={
                                          selectedColl.selectedPrimaryKey === fieldName
                                            ? true
                                            : false
                                        }
                                        disabled={
                                          selectedColl.selectedPrimaryKey === fieldName
                                            ? false
                                            : true
                                        }
                                      />
                                    </CustomRadio>
                                  </div>
                                )}
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-outline-secondary btn-md"
                      title="Skip"
                      type="button"
                      onClick={this.handleCancel}
                    >
                      <i className="wb webconnect-times"></i> Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-theme-submit btn-md ml-3"
                      title="Save Collection"
                      onClick={() => this.handleSave(values, selectedColl.selectedPrimaryKey)}
                      disabled={appwriteCollectionUpdatePending}
                    >
                      <i className="wb webconnect-save-regular"></i> Update
                      <CustomLoader loading={appwriteCollectionUpdatePending} />
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    ) : null;
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppwriteCollectionUpdate);
